import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";

export default function SearchInput(props) {
  const [q, setQ] = useState("");

  function handleChange(ev) {
    const value = ev.target.value;
    setQ(value);

    props.onChange && props.onChange(value);
  }

  function handleSubmit(ev) {
    ev.preventDefault();
    props.onChange && props.onChange(q);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={
        "shadow-md pl-6 px-4 p-2 rounded-3xl flex gap-2 " + props.className
      }
    >
      <input
        value={q}
        onChange={handleChange}
        className="flex-1 min-w-[40px] !outline-none"
        type="text"
        placeholder="Search here"
      />
      <SearchIcon
        onClick={handleSubmit}
        className="cursor-pointer text-theme1 scale-75"
      />
    </form>
  );
}
